import React from 'react';
import SEOMetaTags from '../components/common/SEOMetaTags';
import Hero from '../components/home/Hero';
import BookingSearchBar from '../components/common/BookingSearchBar';
import AboutSection from '../components/home/AboutSection';
import FeaturesSection from '../components/home/FeaturesSection';
import HowToBook from '../components/home/HowToBook';
import AccommodationsSection from '../components/home/AccommodationsSection';
import Testimonials from '../components/common/Testimonials';
import HomeSeoContent from '../components/home/HomeSeoContent';
import FAQ from '../components/common/FAQ';
import BookingCard from '../components/common/BookingCard';
// If homepageScreen.css was moved to home/
import '../components/home/homepageScreen.css';

const HomeIndex = () => {
    const homeFaqs = [
        {
            question: "What areas in Maine do you offer vacation homes in?",
            answer: "Our flagship property, Frost Pine Chalet, is located in Newry, Maine, just minutes from Sunday River Resort. We're expanding our collection of vacation homes to Bethel, Maine, with more western Maine locations to come."
        },
        {
            question: "What makes TimbrLux Stays different from other vacation rental sites?",
            answer: "Every TimbrLux Stays property is thoughtfully designed, professionally cleaned, and personally hosted. Booking direct with us means better rates, faster communication, and a host who's genuinely invested in your stay."
        },
        {
            question: "Are your vacation homes pet-friendly?",
            answer: "Our current property does not allow pets, in line with our house rules. We recommend checking the listing details for each home as we add new locations."
        },
        {
            question: "What is the best time of year to book a vacation home in Maine?",
            answer: "Our Sunday River area homes are a great fit year-round: winter for skiing and snow sports, and spring through fall for hiking, waterfalls, and mountain foliage."
        },
        {
            question: "How many guests can your vacation homes accommodate?",
            answer: "Frost Pine Chalet has 5 bedrooms and comfortably sleeps groups of up to 14 guests, making it ideal for families, reunions, and larger groups."
        },
        {
            question: "Do your properties include amenities like hot tubs or fireplaces?",
            answer: "Yes. Frost Pine Chalet features a private hot tub, sauna, and game room. Full amenity details are listed on each property page."
        },
        {
            question: "How do I book a vacation home rental in Maine with TimbrLux Stays?",
            answer: "You can check availability and book directly through our website using the search bar above, or reach out to our team for help planning your stay."
        },
        {
            question: "Is there a minimum stay requirement?",
            answer: "Minimum stay length can vary by season and property. Select your dates on the property page to see requirements for your specific stay."
        },
        {
            question: "Do you offer luxury stays in Maine for special occasions like anniversaries?",
            answer: "Yes. Our homes are designed for celebrations and romantic retreats, with spacious, comfortable settings that make anniversaries and special trips feel effortless."
        },
        {
            question: "Can I find both lakefront and mountain vacation homes in Maine?",
            answer: "Frost Pine Chalet is a mountain retreat near Sunday River. As we grow, we're adding more vacation homes across Maine, including lakefront settings."
        }
    ];

    return (
        <>
            <SEOMetaTags
                title="TimbrLux Stays | Luxury Vacation Homes & Rentals in Maine"
                description="Luxury vacation homes and rentals across Maine, thoughtfully designed and warmly hosted. Book directly with TimbrLux Stays for an effortless getaway."
                keywords="vacation homes in maine, vacation home rentals in maine, luxury places to stay in maine, vacation homes for rent in maine, rental vacation homes in maine, vacation rental maine, luxury stays in maine, vacation home in maine, holiday homes in maine usa, TimbrLux Stays"
                url="https://www.timbrluxstays.com"
            />

            <main className="homepage">
                <Hero title="Luxury Vacation Homes & Rentals in Maine" />
                <section className="home-booking-search" aria-label="Search and book your stay">
                    <div className="booking-container">
                        <BookingSearchBar />
                    </div>
                </section>
                <AccommodationsSection />
                <AboutSection />
                <FeaturesSection />
                <HowToBook />
                <Testimonials testimonials={[
                    {
                        text: "This is an outstanding home! Came upon this cabin by chance when we were looking for a family vacation. It's a true gem! The views are breathtaking, and the place has such a calm and private feel. It was spotless! The kitchen is fully stocked for meal prep which was important to us. Enjoyed quiet mornings drinking coffee on the deck watching the beautiful light in the trees. There was an amazing sense of peace all around. We really didn't want to leave to visit the town. There were so many amenities. There is a hot tub, game room, and sauna we enjoyed. We spent evenings at the fire pit with our family. Vikas was a wonderland responsive host. We're definitely coming back!",
                        author: "Sangeeta P."
                    },
                    {
                        text: "Met a couple of other families to reconnect and take advantage of the outdoor activities in the area. The house is great for that. it provides large communal areas to hang out with family/friends and it's close to local activities. The house does not disappoint. It looks as good as the pictures. The view of the mountain is amazing. We enjoyed watching New Year's fireworks from the living room.",
                        author: "Kevin H."
                    },
                    {
                        text: "Our family absolutely loved this stay! The mountain views were breathtaking especially at sunrise and sunset. The home was spotless, cozy, and had everything we needed for a relaxing getaway. The host was friendly and responsive, making check-in and communication super easy. It was the perfect mix of peaceful nature and family comfort. We can’t wait to come back, highly recommend!",
                        author: "Felix L."
                    },
                    {
                        text: "A dream rental! The view is even better than the pictures, the amenities are amazing! This place is a gem. Vikas is an amazing host as well! Very proactive and has really thought of everything to create a peaceful and memorable stay. 10 stars!!!",
                        author: "Meridith K."
                    }
                ]} />
                <HomeSeoContent />
                <FAQ faqs={homeFaqs} />
                <BookingCard />
            </main>
        </>
    );
};

export default HomeIndex;
